import { MapGoogleMaps } from './map_googlemaps.js';
import { MarkerGoogleMaps } from './marker_googlemaps.js';
import { PolylineGoogleMaps } from './polyline_googlemaps.js';
import { PopupGoogleMaps } from './popup_googlemaps.js';

export const APIGoogleMaps = {
  Map: MapGoogleMaps,
  MapPolyline: PolylineGoogleMaps,
  MapPopup: PopupGoogleMaps,
  Marker: MarkerGoogleMaps,
};
